/**
 * encuestasService.js
 * Servicio para encuestas de colegio (Admin y Estudiante)
 */
import api from './api';

// ==================== ADMIN ====================

export const getEncuestasAdmin = (esquema) =>
  api.get(`/encuestas?esquema=${esquema}`);

export const crearEncuestaAdmin = (esquema, data) =>
  api.post(`/encuestas?esquema=${esquema}`, data);

export const actualizarEncuestaAdmin = (esquema, id, data) =>
  api.put(`/encuestas/${id}?esquema=${esquema}`, data);

export const eliminarEncuestaAdmin = (esquema, id) =>
  api.del(`/encuestas/${id}?esquema=${esquema}`);

export const activarEncuestaAdmin = (esquema, id) =>
  api.post(`/encuestas/${id}/activar?esquema=${esquema}`);

export const cerrarEncuestaAdmin = (esquema, id) =>
  api.post(`/encuestas/${id}/cerrar?esquema=${esquema}`);

export const getResultadosAdmin = (esquema, id) =>
  api.get(`/encuestas/${id}/resultados?esquema=${esquema}`);

export const getPreguntasAdmin = (esquema, encuestaId) =>
  api.get(`/encuestas/${encuestaId}/preguntas?esquema=${esquema}`);

export const crearPreguntaAdmin = (esquema, encuestaId, data) =>
  api.post(`/encuestas/${encuestaId}/preguntas?esquema=${esquema}`, data);

export const actualizarPreguntaAdmin = (esquema, preguntaId, data) =>
  api.put(`/encuestas/preguntas/${preguntaId}?esquema=${esquema}`, data);

export const eliminarPreguntaAdmin = (esquema, preguntaId) =>
  api.del(`/encuestas/preguntas/${preguntaId}?esquema=${esquema}`);

// ==================== ESTUDIANTE ====================

export const getEncuestasEstudiante = (esquema) =>
  api.get(`/encuestas/disponibles?esquema=${esquema}`);

export const getEncuestaParaResponder = (esquema, id) =>
  api.get(`/encuestas/${id}/responder-encuesta?esquema=${esquema}`);

export const responderEncuesta = (esquema, id, respuestas) =>
  api.post(`/encuestas/${id}/responder-encuesta?esquema=${esquema}`, { respuestas });

const encuestasService = {
  getEncuestasAdmin,
  crearEncuestaAdmin,
  actualizarEncuestaAdmin,
  eliminarEncuestaAdmin,
  activarEncuestaAdmin,
  cerrarEncuestaAdmin,
  getResultadosAdmin,
  getPreguntasAdmin,
  crearPreguntaAdmin,
  actualizarPreguntaAdmin,
  eliminarPreguntaAdmin,
  getEncuestasEstudiante,
  getEncuestaParaResponder,
  responderEncuesta
};

export default encuestasService;
